import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
// import classes from "*.module.css";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import TableContainer from "@material-ui/core/TableContainer";
type DiscountDataProps = {
  discountDetails: {
    discount_amt_count: number;
    discount_amt_total: number;
    total_round_off: number;
    disc_total: number;
    dicount_percentage_total: number;
    discount_percentage_count: number;
  };
  source: string;
};

export const DiscountSummary: FunctionComponent<DiscountDataProps> = ({
  discountDetails,
  source,
}) => {
  const classes = financialItemStyles();

  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>
                Discount Summary
              </Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "50%" }}
                ></TableCell>

                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Bills
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Discount Amount
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {discountDetails.discount_amt_count
                    ? discountDetails.discount_amt_count
                    : "0"}
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {discountDetails.discount_amt_total
                    ? discountDetails.discount_amt_total
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Discount Percentage
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {discountDetails.discount_percentage_count
                    ? discountDetails.discount_percentage_count
                    : "0"}
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {discountDetails.dicount_percentage_total
                    ? discountDetails.dicount_percentage_total
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left" className={classes.headColor}>
                  Round Off
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {"0"}
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  {discountDetails.total_round_off
                    ? discountDetails.total_round_off
                    : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell align="left" className={classes.headCell}>
                  Total
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headColor}
                ></TableCell>
                <TableCell align="right" className={classes.headCell}>
                  {discountDetails.disc_total
                    ? discountDetails.disc_total
                    : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
